/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	IAdminAuthUserResponseData,
	ILoginRequestPayload,
	IAdminLogoutData,
	IAuthStore,
	IAuthRefreshTokenRequestPayload,
	ITokenRequestPayload,
	ITokenResponsePayload,
	IMerchantIdPayload,
	IAuthConnectResponsePayload,
	IAuthConnectRequestPayload,
	ILogoutRequestPayload,
	TSavedUrl,
	IAuthRefreshTokenResponseData,
} from './types';

// ==========================================:
export const initialState: IAuthStore = {
	accessToken: null,
	refreshToken: null,
	socketToken: null,
	isAuthenticated: false,
	loginLoader: false,
	adminLogoutLoader: false,
	email: null,
	loginEmail: null,
	loginPassword: null,
	remember: false,
	userData: null,
	tokenLoader: false,
	xMerchantId: null,
	connect: null,
	connectLoader: false,
	policy: null,
	policyLoader: false,
	savedUrl: null,
	refreshTime: 0,
	refreshTokenResponse: null,
	refreshTokenLoader: false,
	localStorageMessage: null,
	inactivityLogout: false,
};

// ==========================================:
const auth = createSlice({
	name: '@@auth',
	initialState,
	reducers: {
		loginRequest: (state: IAuthStore, action: PayloadAction<ILoginRequestPayload>) => {
			const { payload } = action;
			const loginRequestState = state;

			loginRequestState.loginLoader = true;

			// if (payload.remember) {
			// 	loginRequestState.loginEmail = payload.email;
			// 	loginRequestState.loginPassword = payload.password;
			// }
		},
		loginSuccess: (state: IAuthStore, action: PayloadAction<IAdminAuthUserResponseData>) => {
			const { payload } = action;
			const loginState = state;

			loginState.isAuthenticated = true;
			loginState.loginLoader = false;
			loginState.refreshTokenLoader = false;

			loginState.accessToken = payload.token;
		},
		logoutRequest: (state: IAuthStore, action: PayloadAction<ILogoutRequestPayload>) => {
			const logoutState = state;

			logoutState.adminLogoutLoader = true;
		},
		authInitState: (state: IAuthStore) => {
			const authInitStateState = state;
			return { ...initialState, savedUrl: authInitStateState.savedUrl };
		},
		authInitStateInactivity: (state: IAuthStore) => {
			const authInitStateState = state;
			return { ...initialState, savedUrl: authInitStateState.savedUrl, inactivityLogout: true };
		},
		getTokenRequest: (state: IAuthStore, action: PayloadAction<ITokenRequestPayload>) => {
			const tokenRequestState = state;
			tokenRequestState.tokenLoader = true;
		},
		getTokenSuccess: (state: IAuthStore, action: PayloadAction<ITokenResponsePayload>) => {
			const { payload } = action;
			const tokenSuccessState = state;
			tokenSuccessState.accessToken = payload?.accessToken ?? null;
			tokenSuccessState.refreshToken = payload?.refreshToken ?? null;
			tokenSuccessState.tokenLoader = false;
		},
		refreshTokenRequest: (
			state: IAuthStore,
			action: PayloadAction<IAuthRefreshTokenRequestPayload>,
		) => {
			const { payload } = action;
			const refreshTokenState = state;
			refreshTokenState.refreshToken = payload?.refresh_token ?? null;
			// refreshTokenState.refreshTokenLoader = true;
		},
		refreshTokenSuccess: (state: IAuthStore, action: PayloadAction<number>) => {
			const { payload } = action;
			const refreshTokenResponseState = state;
			refreshTokenResponseState.refreshTime = payload;
			refreshTokenResponseState.refreshTokenLoader = false;
		},
		refreshTokenByTimeOutRequest: (state: IAuthStore) => {},

		setRefreshTokenByTimeOutLoading: (state: IAuthStore) => {
			const refreshTokenState = state;
			refreshTokenState.refreshTokenLoader = true;
		},

		refreshTokenByTimeOutSuccess: (state: IAuthStore) => {
			const refreshTokenState = state;
			refreshTokenState.refreshTokenLoader = false;
		},

		getMerchantIdSuccess: (state: IAuthStore, action: PayloadAction<IMerchantIdPayload>) => {
			const { payload } = action;
			const merchantIdState = state;
			merchantIdState.xMerchantId = payload?.xMerchantId ?? null;
		},
		getConnectRequest: (state: IAuthStore, action: PayloadAction<IAuthConnectRequestPayload>) => {
			const { payload } = action;

			const connectRequestState = state;
			connectRequestState.connectLoader = true;
		},
		getConnectSuccess: (state: IAuthStore, action: PayloadAction<IAuthConnectResponsePayload>) => {
			const { payload } = action;
			const connectSuccessState = state;
			connectSuccessState.connect = payload;
			connectSuccessState.connectLoader = false;
			connectSuccessState.accessToken = payload?.access_token ?? null;
			connectSuccessState.refreshToken = payload?.refresh_token ?? null;
		},
		getPasswordPolicyRequest: (state: IAuthStore) => {
			const passwordPolicyRequestState = state;
			passwordPolicyRequestState.policyLoader = true;
		},
		getPasswordPolicySuccess: (state: IAuthStore, action: PayloadAction<string>) => {
			const { payload } = action;
			const passwordPolicySuccessState = state;
			passwordPolicySuccessState.policy = payload;
			passwordPolicySuccessState.policyLoader = false;
		},
		saveUrl: (state: IAuthStore, action: PayloadAction<TSavedUrl>) => {
			const { payload } = action;
			const saveUrlState = state;
			saveUrlState.savedUrl = payload;
		},
		setLocalStorageMessage: (state: IAuthStore, action: PayloadAction<string>) => {
			const { payload } = action;
			const setLocalStorageMessageState = state;
			setLocalStorageMessageState.localStorageMessage = payload;
		},
	},
});

export default auth.reducer;
export const {
	loginRequest,
	loginSuccess,
	logoutRequest,
	authInitState,
	authInitStateInactivity,
	getTokenRequest,
	getTokenSuccess,
	refreshTokenRequest,
	refreshTokenSuccess,
	getMerchantIdSuccess,
	getConnectRequest,
	getConnectSuccess,
	getPasswordPolicyRequest,
	getPasswordPolicySuccess,
	refreshTokenByTimeOutRequest,
	setRefreshTokenByTimeOutLoading,
	refreshTokenByTimeOutSuccess,
	saveUrl,
	setLocalStorageMessage,
} = auth.actions;
